// extracted by mini-css-extract-plugin
export default {"card":"style_card__xRU2V","title":"style_title__wIYMJ","description":"style_description__SH17G"};